(function () {
  function init(grid) {
    if (grid.dataset.initialized === 'true') return;
    grid.dataset.initialized = 'true';

    var section = grid.closest('.private-flights');
    var locationSelect = section.querySelector('[data-private-location]');
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-private-card]'));
    var apiBase = 'https://flyawayballooning-system.com';
    var requestVersion = 0;

    function currency(amount) {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0 }).format(amount);
    }

    function selectedPrice(voucher) {
      var original = Number(voucher.original_price) || Number(voucher.price_per_person) || 0;
      var sale = Number(voucher.sale_price);
      return sale > 0 && sale < original ? sale : original;
    }

    function setBusy(card, busy) {
      card.setAttribute('aria-busy', busy ? 'true' : 'false');
      card.querySelector('[data-card-book]').disabled = busy;
      card.querySelector('[data-card-later]').disabled = busy;
    }

    function render(card, voucher) {
      var type = card.dataset.privateCard;
      var passengers = Number(card.dataset.passengers) || 2;
      var maxPassengers = Number(voucher.max_passengers) || 2;
      var amount = selectedPrice(voucher);
      card._voucher = voucher;
      card.querySelector('[data-card-error]').hidden = true;
      card.querySelector('[data-card-capacity]').textContent = 'Max ' + maxPassengers;
      card.querySelector('[data-card-days]').textContent = voucher.flight_days || 'Any Day';
      card.querySelector('[data-card-time]').textContent = (voucher.flight_time || 'AM & PM').replace('&', 'or');
      card.querySelector('[data-card-validity]').textContent = (voucher.validity_months || 18) + ' Months';
      card.querySelector('[data-pax-count]').textContent = passengers;
      card.querySelector('[data-pax-minus]').disabled = passengers <= 2;
      card.querySelector('[data-pax-plus]').disabled = passengers >= maxPassengers;
      card.querySelector('.private-flights__card-price strong').textContent = currency(amount);
      card.querySelector('[data-card-total]').textContent = currency(amount);
      card.querySelector('[data-terms-content]').textContent = voucher.terms || 'See the full booking terms for this flight.';
      var image = card.querySelector('.private-flights__card-media img');
      var imageUrl = voucher.image_url || '';
      if (imageUrl.charAt(0) === '/') imageUrl = apiBase + imageUrl;
      if (/^https:\/\//.test(imageUrl)) image.src = imageUrl;
      image.alt = type === 'fiesta' ? 'Bristol Balloon Fiesta private charter balloon flight' : type === 'proposal' ? 'Private balloon proposal flight' : 'Private hot air balloon charter';
      setBusy(card, false);
    }

    function showError(card) {
      card.querySelector('[data-card-error]').hidden = false;
      card.querySelector('.private-flights__card-price strong').textContent = 'Unavailable';
      card.querySelector('[data-card-total]').textContent = 'Unavailable';
      setBusy(card, true);
    }

    function requestVouchers(location, passengers, scope) {
      var query = new URLSearchParams({ location: location, passengers: String(passengers), voucherScope: scope });
      return fetch(apiBase + '/api/private-charter-voucher-types?' + query.toString(), { headers: { Accept: 'application/json' }, cache: 'no-cache' })
        .then(function (response) {
          if (!response.ok) throw new Error('Voucher request failed');
          return response.json();
        })
        .then(function (body) {
          if (!body.success || !Array.isArray(body.data)) throw new Error('Voucher data unavailable');
          return body.data.filter(function (voucher) { return voucher.is_active !== 0 && voucher.is_active !== false; });
        });
    }

    function findVoucher(vouchers, type) {
      return vouchers.find(function (voucher) {
        var title = String(voucher.title || '').toLowerCase();
        return type === 'proposal' ? title.indexOf('proposal') !== -1 : title.indexOf('private charter') !== -1;
      });
    }

    function loadAll() {
      var version = ++requestVersion;
      cards.forEach(function (card) {
        card.dataset.passengers = '2';
        card.dataset.requestVersion = String((Number(card.dataset.requestVersion) || 0) + 1);
        setBusy(card, true);
      });
      Promise.all([
        requestVouchers(locationSelect.value, 2, 'standard'),
        requestVouchers('Bristol Balloon Fiesta', 2, 'bristol_fiesta')
      ]).then(function (results) {
        if (version !== requestVersion) return;
        cards.forEach(function (card) {
          var type = card.dataset.privateCard;
          var voucher = findVoucher(type === 'fiesta' ? results[1] : results[0], type);
          if (voucher) render(card, voucher); else showError(card);
        });
      }).catch(function () {
        if (version !== requestVersion) return;
        cards.forEach(showError);
      });
    }

    function updatePassengers(card, change) {
      var voucher = card._voucher;
      if (!voucher) return;
      var current = Number(card.dataset.passengers) || 2;
      var next = Math.min(Number(voucher.max_passengers) || 2, Math.max(2, current + change));
      if (next === current) return;
      card.dataset.passengers = String(next);
      card.querySelector('[data-pax-count]').textContent = next;
      card.querySelector('[data-pax-minus]').disabled = next <= 2;
      card.querySelector('[data-pax-plus]').disabled = next >= Number(voucher.max_passengers);
      setBusy(card, true);
      var version = (Number(card.dataset.requestVersion) || 0) + 1;
      card.dataset.requestVersion = String(version);
      var type = card.dataset.privateCard;
      var location = type === 'fiesta' ? 'Bristol Balloon Fiesta' : locationSelect.value;
      requestVouchers(location, next, type === 'fiesta' ? 'bristol_fiesta' : 'standard').then(function (vouchers) {
        if (Number(card.dataset.requestVersion) !== version) return;
        var updated = vouchers.find(function (item) { return item.id === voucher.id; });
        if (updated) render(card, updated); else showError(card);
      }).catch(function () {
        if (Number(card.dataset.requestVersion) === version) showError(card);
      });
    }

    function book(card, later) {
      var voucher = card._voucher;
      if (!voucher || card.getAttribute('aria-busy') === 'true') return;
      var type = card.dataset.privateCard;
      var fiesta = type === 'fiesta';
      var url = new URL(grid.dataset.bookUrl || 'https://flyawayballooning-book.com/');
      var params = url.searchParams;
      params.set('source', 'shopify');
      params.set('location', fiesta ? 'Bristol Balloon Fiesta' : locationSelect.value);
      params.set('voucherId', String(voucher.id));
      params.set('voucherTitle', fiesta ? 'Private Bristol Balloon Fiesta Flight' : String(voucher.title || '').trim());
      params.set('passengers', card.dataset.passengers || '2');
      params.set('experience', 'Private Charter');
      params.set('startAt', later ? 'voucher-type' : 'live-availability');
      if (later) params.set('journey', 'flight-voucher');
      if (fiesta) {
        params.set('voucherScope', 'bristol_fiesta');
        params.set('calendarStart', 'next-fiesta');
      }
      window.open(url.toString(), '_blank', 'noopener');
    }

    cards.forEach(function (card) {
      card.dataset.passengers = '2';
      card.querySelector('[data-pax-minus]').addEventListener('click', function () { updatePassengers(card, -1); });
      card.querySelector('[data-pax-plus]').addEventListener('click', function () { updatePassengers(card, 1); });
      card.querySelector('[data-card-book]').addEventListener('click', function () { book(card, false); });
      card.querySelector('[data-card-later]').addEventListener('click', function () { book(card, true); });
      var dialog = card.querySelector('dialog');
      card.querySelector('[data-card-terms]').addEventListener('click', function () { dialog.showModal(); });
      card.querySelector('[data-close-terms]').addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
    });
    locationSelect.addEventListener('change', loadAll);
    loadAll();
  }

  function start() {
    document.querySelectorAll('[data-private-cards]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
